<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="reason">
        <span slot="label">
          <a-tooltip>
            {{$t('注销原因')}}<template slot="title">{{$t('注销原因')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.reason" :maxLength="100" :placeholder="$t('请输入')+$t('注销原因')" />
      </a-form-model-item>
      <a-form-model-item prop="sort">
        <span slot="label">
          <a-tooltip>
            {{$t('排序')}}<template slot="title">{{$t('排序')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.sort" style="width: 100%;" :placeholder="$t('请输入')+$t('排序')" />
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
           {{$t('是否显示')}}<template slot="title">{{$t('是否显示')}}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button :value="1">
            {{$t('是')}}
          </a-radio-button>
          <a-radio-button :value="0">
            {{$t('否')}}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getUserCancelReason, addUserCancelReason, updateUserCancelReason } from '@/api/user/userCancelReason'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        reason: null,

        sort: 1,

        status: 0,

        createTime: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        reason: [
          { required: true, message: '注销原因' + this.$t('不能为空'), trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序' + this.$t('不能为空'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: '状态 1:启用 0:禁用' + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        reason: null,
        sort: null,
        status: 0,
        createTime: null
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserCancelReason({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateUserCancelReason(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addUserCancelReason(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
